/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EstadoVagaEnum = 1 | 2 | 3;

export const EstadoVagaEnum = {

    NUMBER_1: 1 as EstadoVagaEnum,

    NUMBER_2: 2 as EstadoVagaEnum,

    NUMBER_3: 3 as EstadoVagaEnum
};

